import { AddressIPType } from './enums';

export const subnetValues = Array.from({length: 16}, (_, i) => ({label: `/${i + 16}`, value: `${i + 16}`}));
export const bronzeSubnetValues = [{label: '/', value: ''}, ...subnetValues];

export const getIpPair = (ipType: AddressIPType, value: string) => {
    if (ipType === AddressIPType.IP_RANGE) {
        return value?.includes('-') ? value.split('-') : ['', ''];
    }
    if (ipType === AddressIPType.IP_SUBNET) {
        return value?.includes('/') ? value.split('/') : ['', ''];
    }
    return ['', ''];
};

const getNewSubnet = (newValue: string, origIpPair: string[]) => {
    if (origIpPair[0]) {
        const newIpVersion = getIpVersion(newValue);
        const previousIpVersion = getIpVersion(origIpPair[0]);
        if (newIpVersion !== previousIpVersion) {
            return '';
        }
    }
    return origIpPair[1] || '';
};

export const getUpdatedSubnetAddress = (newValue: string, index: number, origIpPair: string[]) => {
    if (index === 0) {
        const newSubnet = getNewSubnet(newValue, origIpPair);
        return (!!newValue || !!newSubnet) ? `${newValue}/${newSubnet}` : '';
    }
    return !origIpPair[0] && !newValue ? '' : `${origIpPair[0] || ''}/${newValue}`;
};

export const getUpdatedRangeAddress = (newValue: string, index: number, origIpPair: string[]): string => {
    const [lowIp, highIp] = origIpPair;

    if (index === 0) {
        return (!newValue && !highIp) ? '' : `${newValue}-${highIp || ''}`;
    }
    return (!newValue && !lowIp) ? '' : `${lowIp || ''}-${newValue}`;
};

export const cleanAddress = (ipValue: string) => {
    if ( ipValue.endsWith('/')) {
        return ipValue.slice(0, -1);
    }

    if ( ipValue.startsWith('/')) {
        return ipValue.slice(0);
    }
    return ipValue.length > 0 ? ipValue : undefined;
};

export const getIpVersion = (ip: string): number => {
    if (isIpv4(ip)) {
        return 4;
    }
    if (isIpv6(ip)) {
        return 6;
    }
    return 0;
};

export const isIpv4 = (ip: string) => {
    return ip.includes('.');
};

export const isIpv6 = (ip: string) => {
    return ip.includes(':');
};